// <s-tap-video>: muted video card. Plays while a mouse hovers it and pauses when it leaves; a tap or click toggles play/pause. The play icon hides while playing.
class STapVideo extends HTMLElement {
  #ac;
  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    const button = this.querySelector('[data-play]');
    const video = this.querySelector('video');
    if (!button || !video) return;
    video.muted = true;
    const icon = button.firstElementChild;
    const play = () => video.play().catch(() => {});
    video.addEventListener('play', () => icon?.classList.add('opacity-0'), { signal });
    video.addEventListener('pause', () => icon?.classList.remove('opacity-0'), { signal });
    this.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') play(); }, { signal });
    this.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') video.pause(); }, { signal });
    button.addEventListener('click', (e) => {
      if (e.pointerType === 'mouse' && !video.paused) return;
      if (video.paused) play(); else video.pause();
    }, { signal });
  }
  disconnectedCallback() {
    this.#ac?.abort();
  }
}
if (!customElements.get('s-tap-video')) customElements.define('s-tap-video', STapVideo);
